export const Scorm2004 = {
    COMPLETION_STATUS: "cmi.completion_status",
    COMPLETION_THRESHOLD: "cmi.completion_threshold",
    PROGRESS_MEASURE: "cmi.progress_measure",
    CREDIT: "cmi.credit",
    ENTRY: "cmi.entry",
    EXIT: "cmi.exit",
    LEARNER_ID: "cmi.learner_id",
    LEARNER_NAME: "cmi.learner_name",
    LESSON_MODE : "cmi.lesson_mode",
    LOCATION: "cmi.location",
    MAX_TIME_ALLOWED: "cmi.max_time_allowed",
    MODE: "cmi.mode",
    SUCCESS_STATUS: "cmi.success_status",
    SCALED_PASSING_SCORE: "cmi.scaled_passing_score",
    SCORE_MIN: "cmi.score.min",
    SCORE_MAX: "cmi.score.max",
    SCORE_RAW: "cmi.score.raw",
    SCORE_SCALED: "cmi.score.scaled",
    SCORE_CHILDREN: "cmi.score._children",
    SUPER_ADMIN_SCORE : "cmi.super_admin.score",
    SESSION_TIME: "cmi.session_time",
    SUSPEND_DATA: "cmi.suspend_data",
    TIME_LIMIT_ACTION: "cmi.time_limit_action",
    CHILDREN : "cmi._children",

    CompletionStatus: {
        COMPLETED: "completed",
        INCOMPLETE: "incomplete",
        NOT_ATTEMPTED: "not attempted",
        UNKNOWN: "unknown"
    },

    SuccessStatus: {
        PASSED: "passed",
        FAILED: "failed",
        UNKNOWN: "unknown"
    },

    ExitStatus: {
        NORMAL : "normal",
        SUSPEND : "suspend"
    }
}
